import React, { useCallback, useEffect, useState } from "react";
import Spin from "../../components/Spin";
import AuthLeftSide from "../../components/AuthLeftSide";
import { API, post } from "../../config";
import { useLocation, useNavigate } from "react-router-dom";
import { ThemeToggle } from "../../components/ThemeToggle";
import { VerifiedIcon, XOctagonIcon } from "lucide-react";
import LogoSVG from "../../components/LogoSVG";
import FaviconSVG from "../../components/FaviconSVG";

const EmailVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const email = query.get("email");
  const token = query.get("token");
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState();
  const [successMessage, setSuccessMessage] = useState(null);
  const EmailVerification = localStorage.getItem("EmailVerification");

  const handleFormSubmit = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await post(API.EMAIL_VERIFICATION, {
        email: email,
        token: token,
      });
      if (data.status === 200) {
        setLoading(false);
        // setRole(data?.data?.role?.slug);
        setRole(data?.data?.role?.type);
        setSuccessMessage(data?.message);
        localStorage.setItem("EmailVerification", 1);
        localStorage.setItem("userId", data?.data?.id);
      }
    } catch (e) {
      setLoading(false);
    }
  }, [email, token]);

  useEffect(() => {
    handleFormSubmit();
  }, [handleFormSubmit]);

  useEffect(() => {
    if (EmailVerification === "1" && successMessage !== null) {
      window.setTimeout(function () {
        role !== "Admin" ? navigate("/") : navigate("/");
      }, 4000);
    }
  }, [navigate, EmailVerification, successMessage, role]);
  return (
    <div className="w-full lg:grid lg:grid-cols-2 min-h-screen">
      {loading && <Spin full={true} />}
      <AuthLeftSide />
      <div className="flex items-center justify-center lg:h-auto min-h-screen lg:flex-row flex-col">
        <LogoSVG className="lg:hidden fixed top-[15%] !text-webPrimary !fill-webPrimary h-28 w-full" />
        <div className="mx-auto grid w-[350px] gap-6">
          {!loading && (
            <div className="flex flex-col items-center justify-center gap-2 text-center">
              {successMessage ? (
                <>
                  <VerifiedIcon size={60} className="text-green-500" />
                  <div className="flex flex-col items-center justify-center gap-2 text-center">
                    <h1 className="text-3xl font-bold">
                      Successfully verified
                    </h1>
                    <p className="text-balance text-muted-foreground">
                      Thank you for verifying your email address.
                    </p>
                    <p className="text-balance text-muted-foreground">
                      Please wait, you will be redirected to the login page.
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <XOctagonIcon size={60} className="text-red-500" />
                  <div className="flex flex-col items-center justify-center gap-2 text-center">
                    <h1 className="text-3xl font-bold">Something Went Wrong</h1>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
        <p className="lg:hidden fixed bottom-0 p-4 text-xs flex items-start gap-1 text-justify">
          <FaviconSVG className="h-5 w-5 !text-webPrimary !fill-webPrimary" />
          <span className="flex-1">
            TrustSoft acknowledges the Traditional Custodians of country
            throughout Australia and their connections to land, sea and
            community. We pay our respect to their Elders past and present and
            extend that respect to all Aboriginal and Torres Strait Islander
            peoples today.
          </span>
        </p>
      </div>
      <div className="fixed top-4 right-4">
        <ThemeToggle />
      </div>
    </div>
  );
};

export default EmailVerification;
